
const digest = '14ca5e8390533d4392328ab88696de0bebc4069d12947cebdb94946d3a3e9af8';
const classes = {"container":"_container_51opv_1"};
const css = `._container_51opv_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-left: 12px;
  padding-top: 20px;
  flex: 1;
  min-height: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  